import { render, staticRenderFns } from "./AuditLogList.vue?vue&type=template&id=21bc0eee&scoped=true"
import script from "./AuditLogList.vue?vue&type=script&lang=js"
export * from "./AuditLogList.vue?vue&type=script&lang=js"
import style0 from "./AuditLogList.vue?vue&type=style&index=0&id=21bc0eee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bc0eee",
  null
  
)

export default component.exports